import type { CycleOperatorSummary } from "./types";

export function summarizeBundle4ShadowLine(cycle?: CycleOperatorSummary | null): string | null {
  const b = cycle?.bundle4Shadow;
  if (!b) return null;
  const deduped = b.wouldBlockDeduped ?? 0;
  const gate = b.gateMin ?? 30;
  return `bundle-4 shadow wouldBlock ${deduped}/${gate}`;
}
